const AVATAR_COLORS = [
  "bg-green-500",
  "bg-yellow-500",
  "bg-blue-500",
  "bg-red-500",
  "bg-purple-500",
  "bg-indigo-500",
  "bg-pink-500",
  "bg-orange-500",
];

/**
 * Get avatar background color class based on a name string.
 * @param {string} name
 * @returns {string} Tailwind background color class
 */
export const getAvatarColor = (name) => {
  const firstChar = name?.charAt(0)?.toUpperCase() || "?";
  return AVATAR_COLORS[(firstChar.charCodeAt(0) || 0) % AVATAR_COLORS.length];
};

/**
 * Common Avatar component that displays a circular avatar
 * with the first character of the given name, or an image when `src` is set.
 *
 * @param {object}  props
 * @param {string}  props.name        – Name to derive initial & color from
 * @param {string}  [props.src]       – Optional image URL (profile photo)
 * @param {string}  [props.colorClass]  – Override background color class (pass "" to skip Tailwind color)
 * @param {string}  [props.className]   – Extra classes to append
 * @param {object}  [props.style]       – Inline styles (e.g. for CSS variable colors)
 */
const Avatar = ({ name, src, colorClass, className = "", style }) => {
  if (src) {
    return (
      <div
        className={`avatar overflow-hidden p-0 ${colorClass ?? ""} ${className}`.trim()}
        style={style}
      >
        <img src={src} alt="" className="w-full h-full object-cover" />
      </div>
    );
  }

  // Support 2-letter initials (e.g. "MT" for Meett Testt) when name length is 2
  const displayChar =
    name && name.length === 2 ? String(name).toUpperCase() : name?.charAt(0)?.toUpperCase() || "?";
  // Use nullish coalescing so passing colorClass="" skips auto-color
  const bgColor = colorClass ?? getAvatarColor(name);

  return (
    <div className={`avatar ${bgColor} ${className}`.trim()} style={style}>
      {displayChar}
    </div>
  );
};

export default Avatar;
